// extracted by mini-css-extract-plugin
export default {"inner":"ParcelAdditionalStatus_inner__kglE8"};